const UPDATES = [
  {
    date: '08-01',
    title: '《星际穿越2》预告片全球首发，诺兰回归科幻巨制',
    tag: '新片速递',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-31',
    title: '暑期档票房突破80亿，《哪吒3》领跑动画电影榜单',
    tag: '行业快讯',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-30',
    title: '花生影院全新升级CDN节点，观影加载速度提升40%',
    tag: '平台公告',
    tagColor: 'bg-secondary-200 text-secondary-800',
  },
  {
    date: '07-29',
    title: '《流浪地球4》确认开机，郭帆导演再续科幻传奇',
    tag: '新片速递',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-28',
    title: '戛纳电影节获奖影片《春风沉醉》独家登陆花生影院',
    tag: '独家上线',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-27',
    title: '花生影院「午夜影院」频道上线，恐怖片爱好者集结',
    tag: '平台公告',
    tagColor: 'bg-secondary-200 text-secondary-800',
  },
  {
    date: '07-26',
    title: 'DC新作《蝙蝠侠：暗夜骑士归来》发布首支预告',
    tag: '新片速递',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            电影行业动态与花生影院最新资源同步，不错过每一部好片
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-secondary-200 space-y-0">
            {UPDATES.map((item, i) => (
              <div
                key={i}
                className="relative pb-8 last:pb-0"
              >
                <div className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100" />

                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs font-medium text-foreground-400 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap w-fit">
                    {item.date}
                  </span>
                  <span
                    className={`text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap w-fit ${item.tagColor}`}
                  >
                    {item.tag}
                  </span>
                </div>

                <p className="mt-2 text-sm md:text-base text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}